"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("./constants");
function isDraft() {
  var referral = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return referral.status === _constants.REFERRAL_STATUS_DRAFT;
}
var _default = exports["default"] = isDraft;